<ng-container>
  <div class="colors">
    <div class="row my-2">
      <div class="col-2">Primary Color:</div>
      <div class="col-10">
        <input
          [cpAlphaChannel]="'disabled'"
          [colorPicker]="color('primary', colors?.primary)"
          [style.background]="color('primary', colors?.primary)"
          (colorPickerChange)="setColor($event, 'primary')"
        />
        <div class="caption">
          <span [style.color]="color('primary', colors?.primary)">Primary</span>
          <span [style.color]="color('primary', colors?.primary)">{{color('primary', colors?.primary)}}</span>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-2">Secondary Color:</div>
      <div class="col-10">
        <input
          [cpAlphaChannel]="'disabled'"
          [colorPicker]="color('secondary', colors?.secondary)"
          [style.background]="color('secondary', colors?.secondary)"
          (colorPickerChange)="setColor($event, 'secondary')"
        />
        <div class="caption">
          <span [style.color]="color('secondary', colors?.secondary)">Secondary</span>
          <span [style.color]="color('secondary', colors?.secondary)">{{color('secondary', colors?.secondary)}}</span>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-2">Text Color:</div>
      <div class="col-10">
        <input
          [cpAlphaChannel]="'disabled'"
          [colorPicker]="color('prose', colors?.prose)"
          [style.background]="color('prose', colors?.prose)"
          (colorPickerChange)="setColor($event, 'prose')"
        />
        <div class="caption">
          <span [style.color]="color('prose', colors?.prose)">Text</span>
          <span [style.color]="color('prose', colors?.prose)">{{color('prose', colors?.prose)}}</span>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-2">Success Color:</div>
      <div class="col-10">
        <input
          [cpAlphaChannel]="'disabled'"
          [colorPicker]="color('success', colors?.success)"
          [style.background]="color('success', colors?.success)"
          (colorPickerChange)="setColor($event, 'success')"
        />
        <div class="caption">
          <span [style.color]="color('success', colors?.success)">Success</span>
          <span [style.color]="color('success', colors?.success)">{{color('success', colors?.success)}}</span>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-2">Warning Color:</div>
      <div class="col-10">
        <input
          [cpAlphaChannel]="'disabled'"
          [colorPicker]="color('warning', colors?.warning)"
          [style.background]="color('warning', colors?.warning)"
          (colorPickerChange)="setColor($event, 'warning')"
        />
        <div class="caption">
          <span [style.color]="color('warning', colors?.warning)">Warning</span>
          <span [style.color]="color('warning', colors?.warning)">{{color('warning', colors?.warning)}}</span>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <div class="col-2">Danger Color:</div>
      <div class="col-10">
        <input
          [cpAlphaChannel]="'disabled'"
          [colorPicker]="color('danger', colors?.danger)"
          [style.background]="color('danger', colors?.danger)"
          (colorPickerChange)="setColor($event, 'danger')"
        />
        <div class="caption">
          <span [style.color]="color('danger', colors?.danger)">Danger</span>
          <span [style.color]="color('danger', colors?.danger)">{{color('danger', colors?.danger)}}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button type="button" class="btn mx-2" [disabled]="!updatingColors" (click)="cancelConfigureColors()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="!updatingColors" (click)="configureColors()">Update App Colors</button>
  </div>
</ng-container>
